import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const SiegeBarracks = {
  id: "11",
  name: "Siege Barracks",
  width: 5,
  height: 6,
  type: BuildingType.BARRACKS,
  era: "romanEmpire",
  icon: "Siege",
  minLevel: 6,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Barracks/Siege_Barracks',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: null,
    minoanEra: null,
    classicGreece: null,
    earlyRome: null,
    romanEmpire: 1,
    byzantineEra: 1,
    ageOfTheFranks: 1,
    feudalAge: 1,
    iberianEra: 1,
    kingdomOfSicily: 1,
    highMiddleAges: 1,
    earlyGothicEra: 1,
    lateGothicEra: 1,
  },
  effects: Effects.create([
    new Happiness({
      stoneAge: null,
      bronzeAge: null,
      minoanEra: null,
      classicGreece: null,
      earlyRome: null,
      romanEmpire: [720, 1440, 2880],
      byzantineEra: [840, 1680, 3360],
      ageOfTheFranks: [1020, 2040, 4080],
      feudalAge: [1200, 2400, 4800],
      iberianEra: [1440, 2880, 5760],
      kingdomOfSicily: [1740, 3480, 6960],
      highMiddleAges: [2100, 4200, 8400],
      earlyGothicEra: [2520, 5040, 10100],
      lateGothicEra: [3000, 6000, 12000],
    })
  ]),
};

export default SiegeBarracks;
